import React from 'react'
import Topbar from '../components/Topbar'
import HeroCarousel from '../components/HeroCarousel'
import SearchBar from '../components/SearchBar'
import AboutSection from '../components/AboutSection'
import Services from '../components/ServiceCard'
import Destination from '../components/Destination'
import Packages from '../components/Packages'
import Gallery from '../components/GallerySection'
import TourBooking from '../components/TourBooking'
import TravelGuide from '../components/TravelGuide'
import Testimonial from '../components/Testimonial'
import Visa from '../components/Visa'
import Cruise from '../components/Cruise'

function Home() {
  return (
    <>
        <div>
            <HeroCarousel />
            <SearchBar />
            <Packages />
            <Visa />
            <Cruise />
            <Services />
            <TourBooking />

            <Testimonial />
        </div>
    </>
  )
}

export default Home